import React, { useState } from "react";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { ShopProvider } from "./ShopContext";
import ShopPage from "./ShopPage";
import { LanguageProvider } from "../../components/LanguageContext";
import { animateScroll as scroll } from "react-scroll";
import { OverflowContainer } from "../Home/HomeElements";
const Shop = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  scroll.scrollToTop();
  return (
    <LanguageProvider>
      <ShopProvider>
        <Sidebar isOpen={isOpen} toggle={toggle}></Sidebar>
        <Navbar toggle={toggle}></Navbar>
        <OverflowContainer>
          <ShopPage></ShopPage>
        </OverflowContainer>
        <Footer></Footer>
      </ShopProvider>
    </LanguageProvider>
  );
};

export default Shop;
